// extracted by mini-css-extract-plugin
module.exports = {"multi-button-wrapper":"MultiButton-module__multi-button-wrapper__3CznY","menu-footer":"MultiButton-module__menu-footer__2s_7Q"};